import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles, useTheme } from '@mui/styles';
import { Box, Drawer, useMediaQuery } from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { BrowserView, MobileView } from 'react-device-detect';
import MenuList from './MenuList';
import { drawerWidth } from '../../store/constant';

/**
 * Styles for the Sidebar component
 */
const useStyles = makeStyles((theme) => ({
    drawer: {
        [theme.breakpoints.up('md')]: {
            width: 0,
            flexShrink: 0
        }
    },
    drawerPaper: {
        width: drawerWidth,
        color: theme.palette.text.primary,
        borderRight: 'none',
        [theme.breakpoints.up('md')]: {
            top: '64px'
        }
    },
    ScrollHeight: {
        height: 'calc(100vh - 70px)',
        paddingLeft: 0,
        paddingRight: 0
    },
    
    customScrollbar: {
        '& .ps__thumb-y': {
          background: 'black',
          width: '6px',
        },
    }
}));


/**
 * Sidebar component
 * @param {Object} props - Component props
 * @param {boolean} props.drawerOpen - Whether the drawer is open
 * @param {function} props.drawerToggle - Function to toggle the drawer
 * @param {function} props.window - Window function
 * @returns {JSX.Element} Sidebar component
 */
const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
    const classes = useStyles();
    const theme = useTheme();
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));

    console.log('matchUpMd:', matchUpMd);

    const drawer = (
        <React.Fragment>
            <BrowserView>
                <PerfectScrollbar component="div" className={`${classes.ScrollHeight} ${classes.customScrollbar}`}>
                    <MenuList />
                </PerfectScrollbar>
            </BrowserView>
            <MobileView>
                <Box sx={{ px: 2 }}>
                    <MenuList />
                </Box>
            </MobileView>
        </React.Fragment>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <nav className={`${classes.drawer} no-print`}  aria-label="mailbox folders">
            <Drawer 
                container={container}
                variant={matchUpMd ? 'persistent' : 'temporary'}
                anchor="left"
                open={drawerOpen}
                onClose={drawerToggle}
                classes={{
                    paper: classes.drawerPaper
                }}
                ModalProps={{ keepMounted: true }}
                color="inherit"
            >
                {drawer}
            </Drawer>
        </nav>
    );
};

/**
 * PropTypes for the Sidebar component
 */
Sidebar.propTypes = {
    drawerOpen: PropTypes.bool,
    drawerToggle: PropTypes.func,
    window: PropTypes.object
};

export default Sidebar;
